import { CalculatorContextType } from '../../../../services/types/Calculator';
import { serviceReducer } from '../../../../shared/hooks/serviceReducer';
import { Action, ApiState } from '../../../../types';

const calculatorReducer = (
  state: ApiState<CalculatorContextType, string>,
  action: Action<CalculatorContextType, string>
): ApiState<CalculatorContextType, string> => serviceReducer(state, action);

export default calculatorReducer;
